import CourseElementModel from './CourseElementModel';
import { backend } from '../../setup';

class PauseModel extends CourseElementModel {
	
	constructor( json:Object ){
		super( json );
	}
	
	get time():number {
		return this.get<number>( 'time' );	
	}
	
	set time( t:number ){
		this.set( 'time', t );	
	}
	
	get title():string {
		return this.get<string>( 'title' );	
	}
	
	set title( t:string ){
		this.set( 'title', t );	
	}
	
}

export default PauseModel;


backend.mapper.toModel.add( 'App\\Pause', function( json:any ) {
	return new PauseModel( json );
});

backend.mapper.toJson.add( 'App\\Pause', function( model:PauseModel ){
	return model.object();
});